"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueBy = void 0;
const uniqueBy = (array, by) => {
    const uniqueArray = [];
    array.forEach(item => {
        const found = uniqueArray.find(it => {
            if (Array.isArray(by)) {
                return by.every(b => it[b] === item[b]);
            }
            return it[by] === item[by];
        });
        if (!found) {
            uniqueArray.push(item);
        }
    });
    return uniqueArray;
};
exports.uniqueBy = uniqueBy;
//# sourceMappingURL=unique-by.js.map